// extracted by mini-css-extract-plugin
export var button = "PartnersSection-module--button--a569c";
export var content = "PartnersSection-module--content--b32f1";
export var secondary = "PartnersSection-module--secondary--9d56a";